import React from 'react';
import { Button, Table, TextLink } from '../common';
import WorkflowStateBadge from '../common/WorkflowStateBadge';
import { useNavigate } from 'react-router-dom';
import serviceNow from '../../services/serviceNow.config';
import DoNotDecryptRequest from '../../models/entities/DoNotDecryptRequest';				
import { WorkflowState } from '../../models/enums/WorkflowState';
import ProgressBarSmall from './components/ProgressBarSmall';

interface DoNotDecryptRequestsByDNDRRowProps {
	request: DoNotDecryptRequest;				
	subOwnerDisplayName?: string;
}

const DoNotDecryptRequestsByDNDRRow = ({ request, subOwnerDisplayName }: DoNotDecryptRequestsByDNDRRowProps) => {
	const navigate = useNavigate();
	const getTicketURL = (ticket: string) => {
		return ticket.toUpperCase().includes('CRQ')
			? `https://itconsole.na.xom.com/#/${ticket}`
			: `https://${serviceNow.serviceNowEnv}.service-now.com/nav_to.do?uri=change_request.do?sysparm_query=number=${ticket}&sysparm_limit=1`;
	};

	const linkToTicket = () => {
		const implementationTicket = request.implementationTicket();
		return implementationTicket !== '' ? (
			<TextLink external href={getTicketURL(implementationTicket)} target="_blank">
				{implementationTicket}&nbsp;
			</TextLink>
		) : (
			'-'
		);
	};

	const handleViewDetails = () => {
		navigate(`/DoNotDecryptRequests/${request.id}`);				
	};

	return (
		<Table.Row key={request.id}>
			<Table.Cell>{request.id}</Table.Cell>
			<Table.Cell>{request.direction.displayName}</Table.Cell>
			<Table.Cell style={{position: 'relative'}}>
				<ProgressBarSmall workflowState={request.workflowInstance.currentWorkflowInstanceState.workflowState} dndrSevenDayExemption={request.sevenDayExemption} scope={request.direction.name}/>
			</Table.Cell>
			<Table.Cell>{linkToTicket()}</Table.Cell>
			<Table.Cell>{request.isAttestation ? 'Yes' : 'No'}</Table.Cell>
			<Table.Cell>{request.workflowInstance.createdBy.displayName}</Table.Cell>
			<Table.Cell>{request.contactUser?.displayName}</Table.Cell>
			<Table.Cell>
							{request.workflowInstance.currentWorkflowInstanceState.workflowState ===
							WorkflowState.PendingSubscriptionOwnerApproval
								? subOwnerDisplayName
								: request.workflowInstance.owner?.displayName}
						</Table.Cell>
			<Table.Cell>
				<Button style={{ width: 120, height: 34 }} onClick={handleViewDetails} variant="primary">
					See Details
				</Button>
			</Table.Cell>
		</Table.Row>
	);
};

export default DoNotDecryptRequestsByDNDRRow;
